<template>
  <div>

    <form>
      <fieldset>
        <legend>Informations de paiement</legend>

        <div v-if="apiError.length > 0" class="message error block">
          <p v-for="error of apiError" v-bind:key="error">
            {{ error }}
          </p>
        </div>

        <div class="fields">
          <div class="field">
            <label for="collectiveNumber" class="required">Code régie</label>
            <input
              id="collectiveNumber"
              @keyup="payment.collectiveNumber = strWithoutSpaces(payment.collectiveNumber)"
              @change="payment.collectiveNumber = strWithoutSpaces(payment.collectiveNumber)"
              type="text"
              maxlength="10"
              :class="{ 'error' : formErrors.collectiveNumber }"
              required
              v-model="payment.collectiveNumber"
              autocomplete="off">
            <p v-if="formErrors.collectiveNumber" class="message error">{{ formErrors.collectiveNumber }}</p>
          </div>
          <div class="field">
            <label for="invoiceNumber" class="required">Numéro de facture</label>
            <input
              id="invoiceNumber"
              @keyup="payment.invoiceNumber = strWithoutSpaces(strToUpperCase(payment.invoiceNumber))"
              @change="payment.invoiceNumber = strWithoutSpaces(strToUpperCase(payment.invoiceNumber))"
              type="text"
              maxlength="30"
              :class="{ 'error' : formErrors.invoiceNumber }"
              required
              v-model="payment.invoiceNumber"
              autocomplete="off">
            <p v-if="formErrors.invoiceNumber" class="message error">{{ formErrors.invoiceNumber }}</p>
          </div>
          <div class="field">
            <label for="amountStr" class="required">Montant</label>
            <div class="collapse">
              <input
                id="amountStr" type="text" maxlength="8"
                @keyup="payment.amountStr = strToFinancialStr(payment.amountStr)"
                @change="payment.amountStr = strToFinancialFloat(payment.amountStr)"
                :class="{ 'error' : formErrors.amountStr }"
                required
                v-model="payment.amountStr"
                autocomplete="off">
              <span>€</span>
            </div>
            <p v-if="formErrors.amountStr" class="message error">{{ formErrors.amountStr }}</p>
          </div>
          <div class="field">
            <label for="email" class="required">Courriel</label>
            <div>
              <input
                id="email"
                @keyup="payment.email = strWithoutSpaces(payment.email)"
                @change="payment.email = strWithoutSpaces(payment.email)"
                type="email"
                maxlength="200"
                :class="{ 'error' : formErrors.email }"
                required
                v-model="payment.email"
                autocomplete="off">
              <span class="tooltip" v-tooltip.top="'Le courriel est obligatoire afin de recevoir la confirmation de transaction de la part du service PAYFIP.'">?</span>
            </div>
            <p v-if="formErrors.email" class="message error">{{ formErrors.email }}</p>
          </div>

          <button v-if="!loading" @click.prevent="sendForm()">Confirmer ma transaction</button>
          <button v-else @click.prevent="" class="disabled"><pulse-loader :color="'rgba(255, 255, 255, 1)'"></pulse-loader></button>
        </div>

        <p class="required-info">* champs requis</p>
      </fieldset>
    </form>

  </div>
</template>

<script>
import InvoicesPaymentService from '@/services/invoicesPaymentService'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    PulseLoader
  },
  data () {
    return {
      loading: false,
      formErrors: {},
      apiError: [],
      payment: {}
    }
  },
  methods: {
    checkForm () {
      var collectiveNumberRegex = /^[0-9]{6}$/
      if (!this.payment.collectiveNumber) {
        this.formErrors.collectiveNumber = 'Le code régie est obligatoire.'
      } else if (!this.payment.collectiveNumber.match(collectiveNumberRegex)) {
        this.formErrors.collectiveNumber = 'Le code régie doit être composé de 6 chiffres.'
      } else {
        this.payment.collectiveNumber = this.strWithoutSpaces(this.payment.collectiveNumber)
      }

      var invoiceNumberRegex = /^([0-9]|[A-Z]|-){1,30}$/
      if (!this.payment.invoiceNumber) {
        this.formErrors.invoiceNumber = 'Le numéro de facture est obligatoire.'
      } else if (!this.payment.invoiceNumber.match(invoiceNumberRegex)) {
        this.formErrors.invoiceNumber = 'Le numéro de facture doit être composé de chiffres, de lettres ou de tirets "-".'
      } else {
        this.payment.invoiceNumber = this.strWithoutSpaces(this.strToUpperCase(this.payment.invoiceNumber))
      }

      var floatRegex = /^([0-9]{1,5}([,|.][0-9]{1,2})?)$/
      if (!this.payment.amountStr) {
        this.formErrors.amountStr = 'Le montant de la facture est obligatoire.'
      } else if (!this.payment.amountStr.match(floatRegex)) {
        this.formErrors.amountStr = "Le montant de la facture n'est pas valide (montant maximum : 99999.99 €)."
      } else {
        this.payment.amountStr = this.strToFinancialStr(this.payment.amountStr)
      }

      var emailRegex = /^[^@ ]+@[^@ .]+\.[^@ .]+$/
      if (!this.payment.email) {
        this.formErrors.email = "L'adresse courriel est obligatoire."
      } else if (this.payment.email && !this.payment.email.match(emailRegex)) {
        this.formErrors.email = "L'adresse courriel n'est pas valide."
      } else {
        this.payment.email = this.strWithoutSpaces(this.payment.email)
      }

      return Object.entries(this.formErrors).length === 0
    },
    strWithoutSpaces (str) {
      if (str) {
        return str.toString().replace(/ /gi, '')
      }
      return str
    },
    strToUpperCase (str) {
      if (str) {
        return str.toString().toUpperCase()
      }
      return str
    },
    strToFinancialStr (str) {
      if (str) {
        str = str.toString().replace(/,/gi, '.')
        str = str.replace(/[a-z]| /gi, '')
      }

      // var minimalFloatRegex = /([0-9]+\.[0-9]{2,}?)/
      // if (str.match(minimalFloatRegex)) {
      //   str = this.strToFinancialFloat(str)
      // }

      return str
    },
    strToFinancialFloat (str) {
      if (str) {
        let float = Number.parseFloat(str)
        if (isNaN(float)) {
          return ''
        } else {
          return float.toFixed(2)
        }
      }

      return str
    },
    sendForm () {
      this.formErrors = {}
      this.apiError = []

      if (this.checkForm()) {
        this.loading = true

        this.payment.amount = (100 * this.strToFinancialFloat(this.payment.amountStr)).toFixed(0)

        new InvoicesPaymentService()
          .sendPayment(this.payment)
          .then(data => {
            console.log(data)
            if (data.success) {
              this.$router.push('/redirect?url=' + data.item)
            } else {
              this.apiError = [data.error.message]
            }
          })
          .catch(error => {
            console.log(error)
            this.$emit('notifyNetworkError')
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
/* Structure form et fieldset */

form {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background: white;
}

form fieldset {
  display: flex;
  flex-direction: column;
  border: none;
}

form legend {
  width: 100%;
  padding: 1.3rem 0;
  font-size: 1.3rem;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  background: rgba(99, 109, 131, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* Groupes label/input, labels et inputs */

form .fields {
  width: 20rem;
  padding: 3rem 4rem;
}

form .field {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.3rem;
}

form .field > div {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

form .field > div input {
  flex: 1;
}

form .field > div.collapse input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

form .field > div span {
  font-weight: bold;
  padding-left: 20px !important;
  padding-right: 20px !important;
  background: rgba(0, 0, 0, 0.02);
  cursor: default;
}

form .field > div.collapse span {
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

form .field > div span.tooltip {
  margin-left: 7px !important;
  margin-right: 0 !important;
  padding-left: 13px !important;
  padding-right: 13px !important;
  border-radius: 50%;
  transform: scale(.65);
}

form label {
  margin-bottom: .5rem;
  text-align: left;
}

form label.required::after {
  content: " *";
  color: red;
}

form input, form button, form .field > div span {
  padding: 10px;
  font-size: .9rem;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: all .1s ease;
  box-shadow: none;
}

form input:focus {
  border-color: rgb(79, 126, 179);
  border-color: var(--primary-light);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;
}

form input.error {
  border-color: rgb(202, 39, 39);
  box-shadow: none;
}

form button {
  width: 100%;
  margin-top: 1rem !important;
  padding: 15px 0 !important;
  font-size: 1rem !important;
  color: white !important;
  background: rgb(79, 126, 179) !important;
  background: var(--primary-light) !important;
  border: none !important;
  cursor: pointer;
  box-shadow: 0 0rem 0 0 rgba(0, 0, 0, 0.2) inset;
}

form button:hover, form button.disabled {
  box-shadow: 0 -4rem 0 0 rgba(0, 0, 0, 0.2) inset;
}

form button.disabled {
  cursor: default;
}

form .required-info {
  text-align: right;
  align-self: flex-end;
  font-style: italic;
  padding: 0 1rem 1rem 2rem;
  font-size: .9rem;
  color: rgb(202, 39, 39);
}

/* Messages du formulaire */

form .message {
  margin-top: .5rem;
  text-align: left;
  font-size: .9rem;
}

form .message.success {
  color: rgb(62, 177, 87);
  border-color: rgb(62, 177, 87);
}

form .message.error {
  color: rgb(202, 39, 39);
}

form .message.error.block {
  margin-top: 0;
  padding: 1rem;
  background: rgba(202, 39, 39, 0.1);
}

/* Spiner du bouton */

form button.spin > * {
  animation: 1.5s infinite spin linear;
}

@keyframes spin {
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
}

/* Responsive */

@media (max-width: 1000px) {
  form .fields {
    padding: 2rem;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  form, form fieldset, form .field, form input, form label {
    display: block;
  }

  form {
    min-width: 450px;
  }

  form legend {
    text-align: center;
  }

  form .fields {
    width: auto;
  }

  form input, form label {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentForm.vue